import { rankings } from '@/mocks/home';

const rankMedals: Record<number, { bg: string; text: string }> = {
  1: { bg: 'bg-primary-500', text: 'text-background-50' },
  2: { bg: 'bg-accent-500', text: 'text-background-50' },
  3: { bg: 'bg-secondary-500', text: 'text-background-50' },
};

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-primary-100/70 text-primary-700 text-xs font-medium px-3 py-1 rounded-full mb-4">
            <i className="ri-trophy-line text-xs"></i>
            <span>实时榜单</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            人气排行
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            实时热度榜单，发现当下最受欢迎的漫画作品
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden">
            {rankings.map((item, i) => {
              const medal = rankMedals[item.rank];
              return (
                <div
                  key={item.title}
                  className={`flex items-center gap-3 md:gap-5 px-4 md:px-6 py-4 md:py-5 ${
                    i < rankings.length - 1 ? 'border-b border-background-200/50' : ''
                  } hover:bg-primary-50/20 transition-colors cursor-pointer`}
                >
                  <div
                    className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold shrink-0 ${
                      medal ? `${medal.bg} ${medal.text}` : 'bg-background-200 text-foreground-500'
                    }`}
                  >
                    {item.rank}
                  </div>

                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="font-medium text-foreground-900 text-sm md:text-base whitespace-nowrap">
                        {item.title}
                      </span>
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{item.author}</span>
                    </div>
                    <div className="flex items-center gap-2 mt-1">
                      <span className="text-xs px-1.5 py-0.5 rounded bg-primary-100 text-primary-700 whitespace-nowrap border border-primary-200/50">
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{item.category}</span>
                    </div>
                  </div>

                  <div className="flex items-center gap-1.5 shrink-0">
                    <i className="ri-fire-line text-sm text-primary-500"></i>
                    <span className="text-sm font-bold text-primary-500 whitespace-nowrap">{item.heat}</span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}